import React from "react";
import "../header.scss";
import { FiX } from "react-icons/fi";
import { Link } from "react-scroll";
const MobileMenu = ({ isOpen, close }) => {
  return (
    <>
      <div className={isOpen ? "mobileSectionsClose" : "mobileSectionsOpen"}>
        <div className="CloseButton">
          <a className="signUpMobile" href="#">
            Sign Up
          </a>
          <FiX onClick={close} />
        </div>
        <div>
          <nav  >
            <ul className="mobileList">
              <li >
                <Link onClick={close}  to="home" smooth={true}>
                  Product
                </Link>
              </li>
              <li  >
                <Link onClick={close} to="useCases" smooth={true}>
                  Use Case
                </Link>
              </li>
              <li>
                <Link onClick={close}  to="learn" smooth={true}>
                  Learn
                </Link>
              </li>
              <li>
                <Link onClick={close}  to="pricing" smooth={true}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link onClick={close}  to="contact" smooth={true}>
                  Comparison
                </Link>
              </li>
              <li>
                <Link onClick={close}  to="form" smooth={true}>
                  Contact Sales
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
